import React from 'react';
import cls from './NuvvyCharacter.module.css';
import idleCharacter from '../../Assets/nuvvy-character/idle.svg';
import waveCharacter from '../../Assets/nuvvy-character/wave.svg';
import talkingCharacter from '../../Assets/nuvvy-character/talking.svg';
import pointLeftCharacter from '../../Assets/nuvvy-character/point-left.svg';
import pointRightCharacter from '../../Assets/nuvvy-character/point-right.svg';
import happyCharacter from '../../Assets/nuvvy-character/happy.svg';

const characterStates = {
  idle: idleCharacter,
  wave: waveCharacter,
  talking: talkingCharacter,
  thinking: talkingCharacter,
  pointLeft: pointLeftCharacter,
  pointRight: pointRightCharacter,
  happy: happyCharacter,
};

const stateClassNames = {
  idle: cls.idle,
  wave: cls.wave,
  talking: cls.talking,
  thinking: cls.thinking,
  pointLeft: cls.pointLeft,
  pointRight: cls.pointRight,
  happy: cls.happy,
};

const sizeClassNames = {
  small: cls.small,
  medium: cls.medium,
  large: cls.large,
};

const NuvvyCharacter = ({
  state = 'idle',
  size = 'medium',
  message = '',
  showBubble = false,
  compact = false,
  className = '',
}) => {
  const safeState = characterStates[state] ? state : 'idle';
  const image = characterStates[safeState];

  return (
    <div className={[cls.root, compact ? cls.compact : '', sizeClassNames[size] || cls.medium, stateClassNames[safeState], className].filter(Boolean).join(' ')}>
      {showBubble && message && (
        <div key={message} className={cls.bubble} aria-live="polite">
          {message}
        </div>
      )}
      <div className={cls.figureWrap}>
        <img className={cls.image} src={image} alt="Nuvvy character" draggable="false" />
      </div>
    </div>
  );
};

export default NuvvyCharacter;
